var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-btn",on:{"click":function($event){return _vm.handleClick(null)}}},[_c('span',[_vm._v("+")])])}
var staticRenderFns = []

export { render, staticRenderFns }